<script>
export default {
  name: "ProgressStatisticIcon",
  props: ['value','goal'],
  methods: {
    calcProgress(division){
      return 100 - ((100-this.value/this.goal*100)/division);
    }
  },
  data() {
    return {
    }
  }
}
</script>

<template>
    <svg viewBox="0 0 36 36">
      <path stroke="#dadada" fill-opacity="0" stroke-width="4" :stroke-dasharray="100 + ','+ 100" d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"></path>
      <path stroke="#bdbcbc" fill-opacity="0" stroke-width="4"  :stroke-dasharray="this.calcProgress(5) + ','+ 100" d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"></path>
      <path stroke="#9d9d9c" fill-opacity="0" stroke-width="4"  :stroke-dasharray="this.calcProgress(2) + ','+ 100" d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"></path>
      <path stroke="#ffa700" fill-opacity="0" stroke-width="4"  :stroke-dasharray="this.calcProgress(1) + ','+ 100" d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"></path>
    </svg>
</template>

